






















import Vue from 'vue';

import ZenButton from '@reciprocity/button';

export default Vue.extend({
  name: 'FooterNavigation',
  components: {
    ZenButton,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
  computed: {
    nextText(): string {
      return this.currentStep < 4 ? 'Next step' : 'Finish scoping';
    },
  },
});
